import { getCurrentTimeInUTC } from '../../../../../shared/components/date-filter/date-filter-options';
import { DateFilter, FilterOperation } from '../types';

export const getProspectFiltersDateDropdownOptions = (
  operation: FilterOperation,
) => {
  const common = [
    {
      key: DateFilter.LAST_WEEK,
      value: DateFilter.LAST_WEEK,
      startDate: getCurrentTimeInUTC().startOf('week').minus({ weeks: 1 }),
      endDate: getCurrentTimeInUTC().startOf('week').minus({ days: 1 }),
    },
    {
      key: DateFilter.THIS_WEEK,
      value: DateFilter.THIS_WEEK,
      startDate: getCurrentTimeInUTC().startOf('week'),
      endDate: getCurrentTimeInUTC(),
    },
    {
      key: DateFilter.LAST_MONTH,
      value: DateFilter.LAST_MONTH,
      startDate: getCurrentTimeInUTC()
        .startOf('month')
        .minus({ months: 1 })
        .startOf('day'),
      endDate: getCurrentTimeInUTC().startOf('month').minus({ days: 1 }),
    },
    {
      key: DateFilter.THIS_MONTH,
      value: DateFilter.THIS_MONTH,
      startDate: getCurrentTimeInUTC().startOf('month'),
      endDate: getCurrentTimeInUTC(),
    },
    {
      key: DateFilter.LAST_YEAR,
      value: DateFilter.LAST_YEAR,
      startDate: getCurrentTimeInUTC()
        .startOf('year')
        .minus({ years: 1 })
        .startOf('day'),
      endDate: getCurrentTimeInUTC().startOf('year').minus({ days: 1 }),
    },
    {
      key: DateFilter.THIS_YEAR,
      value: DateFilter.THIS_YEAR,
      startDate: getCurrentTimeInUTC().startOf('year'),
      endDate: getCurrentTimeInUTC(),
    },
    {
      key: 'custom',
      value: 'Custom',
      startDate: getCurrentTimeInUTC().minus({ days: 30 }),
      endDate: getCurrentTimeInUTC(),
    },
  ];

  if (
    operation === FilterOperation.IS ||
    operation === FilterOperation.IS_BEFORE ||
    operation === FilterOperation.IS_ON_OR_AFTER ||
    operation === FilterOperation.IS_ON_OR_BEFORE
  ) {
    return [
      {
        key: DateFilter.YESTERDAY,
        value: DateFilter.YESTERDAY,
        startDate: getCurrentTimeInUTC().minus({ days: 1 }),
        endDate: getCurrentTimeInUTC(),
      },
      {
        key: DateFilter.TODAY,
        value: DateFilter.TODAY,
        startDate: getCurrentTimeInUTC(),
        endDate: getCurrentTimeInUTC(),
      },
      ...common,
    ];
  }

  if (operation === FilterOperation.IS_AFTER) {
    return [
      {
        key: DateFilter.YESTERDAY,
        value: DateFilter.YESTERDAY,
        startDate: getCurrentTimeInUTC().minus({ days: 1 }),
        endDate: getCurrentTimeInUTC(),
      },
      ...common,
    ];
  }

  return common;
};

export const getIsCustomDateSelected = (options, key: string): boolean => {
  const flattenedArr = options.map((option) => option.key);

  return !flattenedArr.includes(key as DateFilter);
};

export const operationsWithStartAndEndDate = [
  FilterOperation.IS,
  FilterOperation.IS_WITHIN,
];
